import { useMemo, useState } from 'react'

import { PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS } from 'app/KinerjaShared/constants/pelaksanaanSteps'
import { DialogPelaksanaanAppealRollback } from 'app/KinerjaPage/pages/PelaksanaanV2/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealRollback'
import { DialogPelaksanaanAppealRequest } from 'app/KinerjaPage/pages/PelaksanaanV2/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealRequest'
import { LangkahObservasiCard } from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'

import type { LangkahObservasiCardProps } from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'

export const LangkahDokumenRefleksiTindakLanjutCard = (
  props: LangkahObservasiCardProps
) => {
  const CURRENT_STEP = 'DOCUMENT_REFLECTION_FOLLOW_UP'
  const currentStateOrder =
    PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[props?.state]?.order ?? -1

  const [activeDialog, setActiveDialog] = useState<
    'ROLLBACK' | 'APPEAL' | 'NONE'
  >('NONE')

  const stepDeficit =
    currentStateOrder -
    PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[CURRENT_STEP].order

  const handleClickEdit = () => {
    if (stepDeficit === 1 && props.latestFormState === 'NOT_CREATED')
      return setActiveDialog('ROLLBACK')
    return setActiveDialog('APPEAL')
  }

  const overrideState = useMemo(() => {
    if (stepDeficit > 0) return 'done'
    if (stepDeficit === 0) {
      switch (props.latestFormState) {
        case 'SUBMITTED':
          return 'done'
        case 'DRAFT':
          return props.appealState ? 'locked' : 'draft'
        default:
          return props.appealState ? 'locked' : 'unlocked'
      }
    }
    return 'locked'
  }, [props, stepDeficit])

  return (
    <>
      <LangkahObservasiCard
        {...props}
        overrideState={overrideState}
        currentForm={CURRENT_STEP}
        onClickEdit={handleClickEdit}
        isAppealed={props.appealState === CURRENT_STEP}
      />
      <DialogPelaksanaanAppealRollback
        isOpen={activeDialog === 'ROLLBACK'}
        onClose={() => setActiveDialog('NONE')}
        onCancel={() => setActiveDialog('NONE')}
        step={CURRENT_STEP}
        url={`${props.url}`}
      />
      <DialogPelaksanaanAppealRequest
        isOpen={activeDialog === 'APPEAL'}
        step={CURRENT_STEP}
        stepDeficit={stepDeficit}
        onClose={() => setActiveDialog('NONE')}
        initialDialogSize="md"
        headerText="Jika lanjut ubah, isi dokumen ini akan dihapus:"
        infoText="Mohon ajukan perubahan ke atasan terlebih dahulu, ya."
        confirmationText="Saya mengerti bahwa isi Dokumen Refleksi Tindak Lanjut akan dihapus dan saya harus mengulang pengisian."
      />
    </>
  )
}
